import { Box } from '@mui/material';
import { DataGridPro, DataGridProProps, GridColDef } from '@mui/x-data-grid-pro';
import React from 'react';

import { RouterLink } from '../../../app/components/router-link';
import { Partner } from '../../../app/model/mcp/partner';

interface CrisPartnerListGridProps extends Omit<DataGridProProps<Partner>, 'columns'> {
    rows: Partner[];
}

export class CrisPartnerListGrid extends React.Component<CrisPartnerListGridProps> {
    public render(): React.ReactNode {
        return (
            <Box sx={{ width: '100%', display: 'grid', height: '100%' }}>
                <DataGridPro
                    {...this.props}
                    columns={columns}
                    columnVisibilityModel={{
                        sic: false,
                        parentPartnerId: false,
                        comments: false,
                    }}
                />
            </Box>
        );
    }
}

const columns: Array<GridColDef<Partner>> = [
    {
        field: 'id',
        headerName: 'ID',
        width: 100,
        disableColumnMenu: true,
    },
    {
        field: 'name',
        headerName: 'Name',
        width: 350,
        renderCell: (data) => <RouterLink to={`/cris/partners/${data.row.id}`}>{data.value}</RouterLink>,
    },
    {
        field: 'category',
        headerName: 'Category',
        width: 250,
    },
    {
        field: 'merchtype',
        headerName: 'Type',
        width: 150,
    },
    {
        field: 'sic',
        headerName: 'SIC',
        width: 150,
    },
    {
        field: 'parentPartnerId',
        headerName: 'Parent Id',
        width: 120,
        disableColumnMenu: true,
    },
    {
        field: 'active',
        headerName: 'Active',
        width: 100,
        disableColumnMenu: true,
        renderCell: (params) => (params.value ? 'Y' : 'N'),
    },
    {
        field: 'display',
        headerName: 'Display',
        width: 105,
        disableColumnMenu: true,
        renderCell: (params) => (params.value ? 'Y' : 'N'),
    },
    {
        field: 'online',
        headerName: 'Online',
        width: 100,
        disableColumnMenu: true,
        renderCell: (params) => (params.value ? 'Y' : 'N'),
    },
    {
        field: 'comments',
        headerName: 'Comments',
        width: 250,
    },
];
